import React, { useEffect, useState } from 'react'
import './MissionResults.scss'

const MissionResults = (props) => {

    const { result } = props
    
    /** States */
    const [missionResult, setMissionResult] = useState();
    
    useEffect(()=> {
        setMissionResult(handleResults(result.state))
    },[result])

    const handleResults = (state) => {

        switch (state) {

            case 'success': return { state: 'success', text: 'Success' }; break;
            case 'incomplete': return { state: 'incomplete', text: 'Incomplete Data' }; break;
            case 'failure': return { state: 'failure', text: 'Catastrophic Failure' }; break;
            default: return { state: 'failure', text: 'No data' }; break;
        }
    }
    return (
        <div className="mission-results">
        { missionResult && 
            <h2 className='title'>
                Results:
                <span className={missionResult.state}>{missionResult.text}</span>
            </h2>
        }
        </div>
    )
}

export default MissionResults;
